<template>
  <b-container fluid>
    <b-collapse 
      id="filters-collapse"
      v-model="hideResults">
      <b-row>
        <b-col cols="12" sm="4">
          <!-- L1 Province -->
          <b-form-group
            description="L1 Province"
            label-for="l1-province">
            <b-form-select
              :disabled="disableLocationDropdowns" 
              id="l1-province"
              v-model="searchFilters.L1Province.selected" 
              :options="searchFilters.L1Province.options">
            </b-form-select>
          </b-form-group>
          <!-- L2 DC -->
          <b-form-group
            description="L2 DC"
            label-for="l2-dc">
            <b-form-select
              :disabled="disableLocationDropdowns"
              id="l2-dc" 
              v-model="searchFilters.L2DC.selected" 
              :options="searchFilters.L2DC.options">
            </b-form-select>
          </b-form-group>
          <!-- L3 MC -->
          <b-form-group
            description="L3 MC"
            label-for="l3-mc">
            <b-form-select
              :disabled="disableLocationDropdowns"
              id="l3-mc" 
              v-model="searchFilters.L3MC.selected" 
              :options="searchFilters.L3MC.options">
            </b-form-select>
          </b-form-group>
          <!-- L4 MP -->
          <b-form-group
            description="L4 MP"
            label-for="l4-mp">
            <b-form-select
              :disabled="disableLocationDropdowns" 
              id="l4-mp"
              v-model="searchFilters.L4MP.selected" 
              :options="searchFilters.L4MP.options">
            </b-form-select>
          </b-form-group>
          <!-- ClaimID starts with: -->
          <b-form-group
            description="ClaimID starts with"
            label-for="claim-id-starts-with">
            <b-form-input
              id="claim-id-starts-with"
              v-model="searchFilters.ClaimIDStartsWith"
              type="text"
              placeholder="ClaimID starts with:">
            </b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="12" sm="4">
          <!-- HHID starts with: -->
          <b-form-group
            description="HHID starts with"
            label-for="hhid-starts-wth">
            <b-form-input
              id="hhid-starts-wth"
              v-model="searchFilters.HHIDStartsWith"
              type="text"
              placeholder="HHID starts with:">
            </b-form-input>
          </b-form-group>
          <!-- Has this PID: -->
          <b-form-group
            description="Has this PID"
            label-for="has-this-pid">
            <b-form-input
              id="has-this-pid"
              v-model="searchFilters.HasThisPID"
              type="text"
              placeholder="Has this PID:">
            </b-form-input>
          </b-form-group>
          <!-- HH Interview Started: -->
          <b-form-group
            description="HH Interview Started"
            label-for="hh-interview-started">
            <b-form-select
              id="hh-interview-started" 
              v-model="searchFilters.HHInterviewStarted.selected" 
              :options="searchFilters.HHInterviewStarted.options">
            </b-form-select>
          </b-form-group>
          <!-- Has a HH Visit: -->
          <b-form-group
            description="Has a HH Visit"
            label-for="has-a-hh-visit">
            <b-form-select 
              id="has-a-hh-visit"
              v-model="searchFilters.HasAHHVisit.selected" 
              :options="searchFilters.HasAHHVisit.options">
            </b-form-select>
          </b-form-group>
          <!-- Cluster starts with: -->
          <b-form-group
            description="Cluster starts with"
            label-for="cluster-starts-with">
            <b-form-input
              id="cluster-starts-with"
              v-model="searchFilters.ClusterStartsWith"
              type="text"
              placeholder="Cluster starts with:">
            </b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="12" sm="4">
          <!-- Team Leader OK: -->
          <b-form-group
            description="Team Leader OK"
            label-for="team-leader-okay">
            <b-form-select
              id="team-leader-okay" 
              v-model="searchFilters.TeamLeaderOK.selected" 
              :options="searchFilters.TeamLeaderOK.options">
            </b-form-select>
          </b-form-group>
          <!-- Interviewer -->
          <b-form-group
            description="Interviewer"
            label-for="interviewer">
            <b-form-select
              id="interviewer" 
              v-model="searchFilters.Interviewer.selected" 
              :options="searchFilters.Interviewer.options">
            </b-form-select>
          </b-form-group>
          <!-- Household Outcome: -->
          <b-form-group
            description="Bundle Outcome"
            label-for="bundle-outcome">
            <b-form-select
              id="bundle-outcome" 
              v-model="searchFilters.BundleOutcome.selected" 
              :options="searchFilters.BundleOutcome.options">
            </b-form-select>
          </b-form-group>
          <!-- Team Led by: -->
          <b-form-group
            description="Team Led by"
            label-for="team-led-by">
            <b-form-select
              id="team-led-by" 
              v-model="searchFilters.TeamLedBy.selected" 
              :options="searchFilters.TeamLedBy.options">
            </b-form-select>
          </b-form-group>
          <!-- Household Exception: -->
          <b-form-group
            description="Household Exception"
            label-for="household-exception">
            <b-form-select
              id="household-exception" 
              v-model="searchFilters.HouseholdException.selected" 
              :options="searchFilters.HouseholdException.options">
            </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="4" order="3" order-sm="1" class="pb-4 pb-sm-0"> 
          <b-button
            variant="success" 
            block
            :disabled="!canSearch() || waitingTable" 
            @click="search()">
            Search <b-spinner small v-if="waitingTable" class="align-middle"></b-spinner>
          </b-button>
        </b-col>
        <b-col sm="4" order="2" order-sm="2" class="pb-2 pb-sm-0">
          <b-button 
            variant="danger"
            block 
            @click="resetFiltersSelections()">
            Clear
          </b-button>
        </b-col>
        <b-col sm="4" order="1" order-sm="3" class="pb-2 pb-sm-0">
          <!-- Sort by: -->
          <b-form-group
            description="Sort by:"
            label-for="sort-by">
            <b-form-select 
              id="sort-by"
              v-model="searchFilters.SortBy.selected" 
              :options="searchFilters.SortBy.options">
            </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
    </b-collapse>
    <b-collapse
      id="results-collapse"
      v-model="showResults">
      <b-row class="mb-2">
        <b-col sm="4">
          <b-row>
            <b-col md="6" class="pb-1 pb-md-0">
              <b-button
                :disabled="canReport"
                variant="info" 
                block 
                v-if="table.items.length > 0" 
                @click="generatexlsx()">
                Report
              </b-button>
            </b-col>
            <b-col md="6" class="pb-1 pb-md-0">
              <b-button 
                variant="warning"
                block
                @click="showResults = false">
                Filters
              </b-button>
            </b-col>
          </b-row>
        </b-col>
        <b-col sm="8">
          <b-row>
            <b-col md="6">
              <b-pagination
                align="fill"
                :disabled="waitingTable"
                v-model="searchFilters.pageNum"
                :total-rows="searchFilters.numRows"
                :per-page="searchFilters.pageSize.selected">
              </b-pagination>
            </b-col>
            <b-col md="6">
              <b-row>
                <b-col cols="6">
                  <p>page {{ searchFilters.pageNum }} of {{ searchFilters.numPages }}</p>
                </b-col>
                <b-col cols="6">
                  <b-form-select
                    :disabled="waitingTable"
                    v-model="searchFilters.pageSize.selected"
                    :options="searchFilters.pageSize.options">
                  </b-form-select>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-table
        v-if="resultCount > 0" 
        small
        responsive
        striped
        stacked="md"
        :busy="waitingTable"
        :items="table.items" 
        :fields="table.fields">
        <div slot="table-busy" class="text-center text-danger my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
        <!-- button that links to household location -->
        <template slot="HouseholdLocation" slot-scope="data">
          <b-button 
            @click="$router.push({name: 'LocationDetails', params: {hhid: data.item.HHID}})">
            location
          </b-button>
        </template>
        <!-- button that links to household page -->
        <template slot="FamilyName" slot-scope="data">
          <b-button 
            @click="$router.push({path: `/household/${data.item.HHID}`})">
            {{ data.item.FamilyName }}
          </b-button>
        </template>
        <!-- button that links to household status page -->
        <template slot="Status" slot-scope="data">
          <b-button 
            :variant="statusButtonVariant(data.item.Status)"
            @click="$router.push({path: `/householdstatus/${data.item.HHID}`})">
            Status
          </b-button>
        </template>
        <!-- button that links to household exceptions page -->
        <template slot="Exceptions" slot-scope="data">
          <b-button 
            :variant="exceptionButtonVariant(data.item.Exception)"
            @click="$router.push({path: `/exceptions/${data.item.HHID}`})">
            Exceptions
          </b-button>
        </template>
        <!-- OK TL boolean rendered as a read-only checkbox -->
        <template slot="OKTL" slot-scope="data">
          <div v-if="data.item.OKTLClickable && !waitingOKTL">
            <b-form-checkbox
              @change="tickTeamLeaderOK($event, data.item.HHID)"
              v-model="data.item.OKTL">
            </b-form-checkbox>
          </div>
          <div v-else-if="data.item.OKTLClickable && waitingOKTL">
            <b-spinner
              small
              label="Loading...">
            </b-spinner>
          </div>
          <div v-else>
            <b-form-checkbox
              disabled
              v-model="data.item.OKTL">
            </b-form-checkbox>
          </div>
        </template>
        <!-- LastVisitOutcome rendered as a link to the household visits page -->
        <template slot="BundleLastVisitOutcome" slot-scope="data">
          <a
            href
            @click.prevent="$router.push({path: `/householdvisits/${data.item.HHID}`})">
            {{ data.item.BundleLastVisitOutcome }}
          </a>
        </template>
        <template slot="Notes" slot-scope="data">
          <b-button
            :variant="data.item.Notes ? 'primary' : 'secondary'"
            @click="$router.push({path: `/householdnotes/${data.item.HHID}`})">
            Notes
          </b-button>
        </template>
      </b-table>
    </b-collapse>
  </b-container>
</template>

<script>
import { apiService } from '../_services'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'Main',
  data() {
    return {
      waitingTable: false,
      waitingOKTL: false,
      showResults: false,
      hideResults: true,
      disableLocationDropdowns: false,
      table: {
        fields: [
          {
            key: 'Cluster',
            label: 'Cluster'
          },
          {
            key: 'HHID',
            label: 'HH ID'
          },
          {
            key: 'ClaimID',
            label: 'Claim ID'
          },
          {
            key: 'ClaimName',
            label: 'Claim Name'
          },
          {
            key: 'FamilyName',
            label: 'Family Name'
          },
          {
            key: 'DateBundleStarted',
            label: 'Date Bundle Started'
          },
          {
            key: 'BundleLastVisitOutcome',
            label: 'Bundle Last Visit Outcome'
          },
          // fake field that is a button that links to household location
          {
            key: 'HouseholdLocation',
            label: 'Location'
          },
          // bool that needs to be rendered as a checkbox
          {
            key: 'OKTL',
            label: 'OK TL'
          },
          {
            key: 'AssignedInterviewer',
            label: 'Interviewer'
          },
          // fake field that is a button that links to household status
          {
            key: 'Status',
            label: 'Status'
          },
          // fake field that is a button that links to household exceptions
          {
            key: 'Exceptions',
            label: 'Exceptions'
          },
          {
            key: 'Notes',
            label: 'Notes'
          },
          // hidden field
          {
            key: 'OKTLClickable',
            thClass: 'd-none', 
            tdClass: 'd-none' 
          }
        ],
        items: []
      },
      searchFilters: {
        L1Province: {
          selected: null,
          options: []
        },
        HHIDStartsWith: null,
        TeamLeaderOK: {
          selected: null,
          options: []
        },
        L2DC: {
          selected: null,
          options: []
        },
        HasThisPID: null,
        Interviewer: {
          selected: null,
          options: []
        },
        L3MC: {
          selected: null,
          options: []
        },
        HHInterviewStarted: {
          selected: null,
          options: []
        },
        BundleOutcome: {
          selected: null,
          options: []
        },
        L4MP: {
          selected: null,
          options: []
        },
        HasAHHVisit: {
          selected: null,
          options: []
        },
        TeamLedBy: {
          selected: null,
          options: []
        },
        ClaimIDStartsWith: null,
        ClusterStartsWith: null,
        HouseholdException: {
          selected: null,
          options: []
        },
        SortBy: {
          selected: null,
          options: []
        },
        pageNum: 1,
        pageSize: {
          selected: 4,
          options: [
            {value: 4, text: '4'},
            {value: 8, text: '8'},
            {value: 12, text: '12'},
            {value: 16, text: '16'},
            {value: 20, text: '20'},
          ]
        }, // 4 results show nicely on tablet
        numPages: 0,
        numRows: 0
      }
    }
  },
  created() {
    // get any notes when this page loads for the first time, this is an easy
    // way to make the client fetch unread notes as soon as possible after login
    // since this page is hit first
    this.fetchUnread()
    this.instantiateFilters()
    let vm = this
    apiService.getFilterOptions().then((response) => {
      console.log(response.data)
      vm.searchFilters.L1Province.options.push(...response.data.L1ProvinceOptions)
      vm.searchFilters.TeamLeaderOK.options.push(...response.data.TeamLeaderOKOptions)
      vm.searchFilters.Interviewer.options.push(...response.data.InterviewerOptions)
      vm.searchFilters.HHInterviewStarted.options.push(...response.data.HHInterviewStartedOptions)
      vm.searchFilters.BundleOutcome.options.push(...response.data.BundleOutcomeOptions)
      vm.searchFilters.HasAHHVisit.options.push(...response.data.HasAHHVisitOptions)
      vm.searchFilters.TeamLedBy.options.push(...response.data.TeamLedByOptions)
      vm.searchFilters.HouseholdException.options.push(...response.data.HouseholdExceptionOptions)
      vm.searchFilters.SortBy.options.push(...response.data.SortByOptions)
    })
  },
  watch: {
    'searchFilters.pageSize.selected'(newValue, oldValue) {
      this.search()
    },
    // watch for when the user paginates through the data
    'searchFilters.pageNum'(newValue, oldValue) {
      this.search()
    },
    // refresh results when coming back to this page from elsewhere
    // but only if the results were open and not the filters
    $route (to, from) {
      if (to.name === 'Main' && this.showResults) {
        this.search()
      }
    },
    // keeps hideResults synced with showResults, having both is needed for
    // how bootstrap vue does collapse element show/hide
    showResults() {
      this.hideResults = !this.showResults
    },
    // populate L2DC options when L1Province is changed
    'searchFilters.L1Province.selected'(newValue, oldValue) {
      // console.log(`searchFilters.L1Province.selected has changed from ${oldValue} to ${newValue}`)
      this.searchFilters.L2DC.options = [{value: null, text: '(none)'}]
      this.searchFilters.L2DC.selected = null
      if (newValue === null) {
        return
      }
      this.disableLocationDropdowns = true
      let vm = this
      apiService.getL2DCOptions(Number(newValue))
      .then((response) => {
        vm.searchFilters.L2DC.options.push(...response.data.L2DCOptions)
        vm.disableLocationDropdowns = false
      }).catch(() => {vm.disableLocationDropdowns = false})
    },
    // populate L3MC options when L2DC is changed
    'searchFilters.L2DC.selected'(newValue, oldValue) {
      // console.log(`searchFilters.L2DC.selected from ${oldValue} to ${newValue}`)
      this.searchFilters.L3MC.options = [{value: null, text: '(none)'}]
      this.searchFilters.L3MC.selected = null
      if (newValue === null) {
        return
      }
      this.disableLocationDropdowns = true
      let vm = this
      apiService.getL3MCOptions(Number(newValue))
      .then((response) => {
        vm.searchFilters.L3MC.options.push(...response.data.L3MCOptions)
        vm.disableLocationDropdowns = false
      }).catch(() => {vm.disableLocationDropdowns = false})
    },
    // populate L4MP options when L3MC is changed
    'searchFilters.L3MC.selected'(newValue, oldValue) {
      // console.log(`searchFilters.L3MC.selected from ${oldValue} to ${newValue}`)
      this.searchFilters.L4MP.options = [{value: null, text: '(none)'}]
      this.searchFilters.L4MP.selected = null
      if (newValue === null) {
        return
      }
      this.disableLocationDropdowns = true
      let vm = this
      apiService.getL4MPOptions(Number(newValue))
      .then((response) => {
        vm.searchFilters.L4MP.options.push(...response.data.L4MPOptions)
        vm.disableLocationDropdowns = false
      }).catch(() => {vm.disableLocationDropdowns = false})
    },
  },
  computed: {
    ...mapGetters('auth', ['getIsAdminHQ', 'getIsSupportHQ', 'getIsHQView']),
    canReport() {
      return !(this.getIsAdminHQ || this.getIsSupportHQ || this.getIsHQView)
    },
    resultCount() {
      return this.table.items.length
    } 
  },
  methods: {
    ...mapActions('notes', {fetchUnread: 'fetchUnreadNotes'}),
    tickTeamLeaderOK(checked, hhid) {
      this.waitingOKTL = true
      // console.log({event, hhid})
      let vm = this
      apiService.tickOKTL(checked, hhid)
      .then((resp) => {
        vm.search()
        this.waitingOKTL = false
      })
      .catch((err) => {
        this.waitingOKTL = false
        // this.$bvModal.msgBoxOk('placeholder')
      })
    },
    canSearch() {
      //...
      return true
    },
    instantiateFilters() {
      this.searchFilters.L1Province.selected = null
      this.searchFilters.L1Province.options = [{value: null, text: '(none)'}]
      this.searchFilters.HHIDStartsWith = null
      this.searchFilters.TeamLeaderOK.selected = null
      this.searchFilters.TeamLeaderOK.options = [{value: null, text: '(none)'}]
      this.searchFilters.L2DC.selected = null
      this.searchFilters.L2DC.options = [{value: null, text: '(none)'}]
      this.searchFilters.HasThisPID = null
      this.searchFilters.Interviewer.selected = null
      this.searchFilters.Interviewer.options = [{value: null, text: '(none)'}]
      this.searchFilters.L3MC.selected = null
      this.searchFilters.L3MC.options = [{value: null, text: '(none)'}]
      this.searchFilters.HHInterviewStarted.selected = null
      this.searchFilters.HHInterviewStarted.options = [{value: null, text: '(none)'}]
      this.searchFilters.BundleOutcome.selected = null
      this.searchFilters.BundleOutcome.options = [{value: null, text: '(none):'}]
      this.searchFilters.L4MP.selected = null
      this.searchFilters.L4MP.options = [{value: null, text: '(none)'}]
      this.searchFilters.HasAHHVisit.selected = null
      this.searchFilters.HasAHHVisit.options = [{value: null, text: '(none)'}]
      this.searchFilters.TeamLedBy.selected = null
      this.searchFilters.TeamLedBy.options = [{value: null, text: '(none)'}]
      this.searchFilters.ClaimIDStartsWith = null
      this.searchFilters.ClusterStartsWith = null
      this.searchFilters.HouseholdException.selected = null
      this.searchFilters.HouseholdException.options = [{value: null, text: '(none)'}]
      this.searchFilters.SortBy.selected = null
      this.searchFilters.SortBy.options = [{value: null, text: '(none)'}]
    },
    resetFiltersSelections() {
      this.searchFilters.L1Province.selected = null
      this.searchFilters.HHIDStartsWith = null
      this.searchFilters.TeamLeaderOK.selected = null
      this.searchFilters.L2DC.selected = null
      this.searchFilters.HasThisPID = null
      this.searchFilters.Interviewer.selected = null
      this.searchFilters.L3MC.selected = null
      this.searchFilters.HHInterviewStarted.selected = null
      this.searchFilters.BundleOutcome.selected = null
      this.searchFilters.L4MP.selected = null
      this.searchFilters.HasAHHVisit.selected = null
      this.searchFilters.TeamLedBy.selected = null
      this.searchFilters.ClaimIDStartsWith = null
      this.searchFilters.ClusterStartsWith = null
      this.searchFilters.HouseholdException.selected = null
      this.searchFilters.SortBy.selected = null

      this.table.items = []
    },
    getSearchParams() {
      let params = {
        "L1Province": this.searchFilters.L1Province.selected,
        "HHIDStartsWith": this.searchFilters.HHIDStartsWith,
        "TeamLeaderOK": this.searchFilters.TeamLeaderOK.selected,
        "L2DC": this.searchFilters.L2DC.selected,
        "HasThisPID": this.searchFilters.HasThisPID,
        "AssignedInterviewer": this.searchFilters.Interviewer.selected,
        "L3MC": this.searchFilters.L3MC.selected,
        "HHInterviewStarted": this.searchFilters.HHInterviewStarted.selected,
        "BundleOutcome": this.searchFilters.BundleOutcome.selected,
        "L4MP": this.searchFilters.L4MP.selected,
        "HasAHHVisit": this.searchFilters.HasAHHVisit.selected,
        "TeamLedBy": this.searchFilters.TeamLedBy.selected,
        "ClaimIDStartsWith": this.searchFilters.ClaimIDStartsWith,
        "ClusterStartsWith": this.searchFilters.ClusterStartsWith,
        "HouseholdException": this.searchFilters.HouseholdException.selected,
        "SortBy": this.searchFilters.SortBy.selected,
        "PageNum": this.searchFilters.pageNum,
        "PageSize": this.searchFilters.pageSize.selected,
      }
      return params 
    },
    search() {
      let params = this.getSearchParams()
      let vm = this
      this.waitingTable = true
      apiService.getMainMenuResults(params)
      .then((response) => {
        //console.log(response.data)
        vm.searchFilters.numPages = response.data.NumPages
        vm.searchFilters.numRows = response.data.NumRows
        vm.table.items = response.data.Results
        vm.waitingTable = false
        if (vm.table.items.length === 0) {
          vm.$bvModal.msgBoxOk('0 results for current filter selections')
          .then(() => {
            vm.$router.push({path: '/'})
          })
        } else {
          vm.showResults = true
        }
      })
    },
    generatexlsx() {
      let params = this.getSearchParams()
      apiService.xlsxgen(params)
      .then(() => {
        console.log('report received')
      })
    },
    statusButtonVariant(status) {
      if (status == 0) {
        return "danger"
      } else if (status == 1) {
        return "success"
      } else if (status == 2) {
        return "secondary"
      }
    },
    exceptionButtonVariant(exception) {
      if (exception == 0) {
        return "secondary"
      } else if (exception == 1) {
        return "primary"
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/MainPage.vue